import { UPDATE_EMPLOYEE_GLOBAL_SETUP } from './globalSetup.actions';

import initialState from './globalSetupInitialValues';

/**
 * @param {{
 *   isEmployeesArchiveHidden: boolean,
 *   employeeDisplayOrganizationalPathLength: number,
 *   isGlobalSetupDataLoaded: boolean,
 *   reset: any
 * }} state
 * @param {ShiftBidding.IAction} action
 * */
// eslint-disable-next-line default-param-last
const employeeGlobalSetupAppDataReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case UPDATE_EMPLOYEE_GLOBAL_SETUP:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
};

export default employeeGlobalSetupAppDataReducer;
